import React from 'react';

const SaleTag = 'https://tora-tora.net/js/Bootstrap4-alpha6/dev/images/icon/sale.svg';

const AdPrice = (data) => (
  <div className="ad-travel__price">
    {data.sale ?
      <div>
        <img className="sale-tag" src={SaleTag} alt=""/>
        {data.original &&
        <s className="mr-1" style={{fontSize: '0.71em', color: '#d9534f'}}>${data.original}</s>
        }
        <span>${data.lowest}~</span>
      </div>
      :
      <div>
        ${data.lowest}~
      </div>
    }
  </div>
);

export default AdPrice;



// WEBPACK FOOTER //
// ./src/pages/ad/components/AdPrice.js